module.exports = __webpack_public_path__ + "static/about-liz-img-no-color-1-894a06b1b8aa5fcbf6bc11ecaa465a93.png";